import { Injectable } from '@angular/core';
import { Router,ActivatedRouteSnapshot,CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthentificationService } from 'projects/hp-api/src/lib/services/authentification-service.service';
@Injectable({
  providedIn: 'root'
})
export class AuthGuardGuard implements CanActivate {

  constructor(
    private router: Router,
    private authentificationService: AuthentificationService
) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
       
   
    // not logged in so redirect to login page with the return url
    this.router.navigate(['/swao'] );
    return false;
}
  
}
